/**
 * Inline fallback (no network/static file dependency).
 * Keep this simple and tiny so every failed media URL can always resolve to a visible neutral box.
 */
const OFFLINE_MEDIA_PLACEHOLDER_DATA_URI =
  "data:image/svg+xml;utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='80' viewBox='0 0 120 80' role='img' aria-hidden='true'%3E%3Crect width='120' height='80' fill='%23e5e7eb'/%3E%3C/svg%3E";

/**
 * Runtime image fallback source for Vue templates / @error handlers.
 * Uses a data URI so it still works when `/offline-media-placeholder.svg` is unavailable.
 */
export function offlineMediaPlaceholderUrl(): string {
  return OFFLINE_MEDIA_PLACEHOLDER_DATA_URI;
}

/**
 * Handler for `<img @error>` — swap failed media loads to the offline placeholder.
 */
export function onOfflineMediaImgError(e: Event): void {
  const img = e.target as HTMLImageElement;
  if (img.dataset.indmoImgFallbackApplied === '1') return;
  img.dataset.indmoImgFallbackApplied = '1';
  const picture = img.closest('picture');
  if (picture) {
    picture.querySelectorAll('source').forEach((source) => {
      source.removeAttribute('srcset');
    });
  }
  img.removeAttribute('srcset');
  img.removeAttribute('sizes');
  img.src = offlineMediaPlaceholderUrl();
}
